import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import Lottie from 'lottie-react'
import { Card } from '../../../Card'
import animationData from '../../assets/lottie/cancel.json'

const Container = styled('div')`
  display: grid;
  place-items: center;
`

const Success = () => (
  <Card>
    <Container>
      <Lottie animationData={animationData} loop={false} style={{ height: '16rem' }} />
      <Typography variant="h1" textAlign="center">
        Appointment was successfully canceled
      </Typography>
    </Container>
  </Card>
)

export { Success }
